module.exports = __webpack_public_path__ + "img/change-product.f20c9b5f.png";